var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "预览",
        visible: _vm.dialogVisible,
        width: "800px",
        "append-to-body": "",
        top: "10px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("iframe", {
        staticStyle: { border: "0", height: "800px", width: "100%" },
        attrs: {
          src: `./file-viewer/index.html?useOfficeMicroOnline=false&fileUrl=${_vm.fileUrl}`,
          scrolling: "auto",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }